import { Button, LinearProgress, Stack, Typography } from '@mui/material';
import { AuthContext, CartContext, CateringContext } from 'constants/contexts';
import React, { useContext, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { priceTransformer } from 'utils';
import { getActionText } from 'utils/cart';
import { getItemTotalPrice } from 'utils/item';

function CartAction() {
  const {
    items, minimumOrderPrice, closeCart,
  } = useContext(CartContext);
  const { isLoggedIn, user } = useContext(AuthContext);
  const catering = useContext(CateringContext);
  const totalPrice = useMemo(() => items.reduce((total, item) => total + getItemTotalPrice(item), 0), [items]);
  const history = useHistory();

  const handleCheckout = (e) => {
    closeCart();
    if (isLoggedIn && !user?.name) {
      history.push('/signup');
      return;
    }

    setTimeout(() => {
      catering.continueToCheckout();
    }, 100);
  };

  function renderButton() {
    const disabled = items.length === 0 || totalPrice < minimumOrderPrice;
    if (disabled) {
      return;
    }
    return (
      <>
        {catering?.headcount < 1 &&
        <Typography variant="body-caption" color="text.secondary" sx={{ textAlign: 'center', pb: 1 }}>Add your headcount
          for cost per person</Typography>}
        <Button
          fullWidth
          variant={isLoggedIn && !user?.name ? 'muted' : 'contained'}
          size="large"
          onClick={handleCheckout}
          disabled={disabled}
          sx={{ height: 56 }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <Typography textTransform="none">{getActionText({ isLoggedIn, user })}</Typography>
            <Stack alignItems="end">
              <Typography>{priceTransformer(totalPrice)}</Typography>
              {catering?.headcount > 0 && (
                <Typography variant="body2">
                  {priceTransformer(totalPrice / (catering?.headcount || 1))}
                  {' '}
                  / person
                </Typography>
              )}
            </Stack>
          </Stack>
        </Button>
      </>
    );
  }

  return (
    <Stack marginTop="auto" spacing={1} sx={{ width: '100%' }}>
      {items.length > 0 && totalPrice < minimumOrderPrice && (
        <Stack gap={1}>
          <Typography variant="body-md">
            {priceTransformer(totalPrice)}
          </Typography>
          <LinearProgress
            variant="determinate"
            sx={{
              height: 6,
              borderRadius: 1,
              '&.MuiLinearProgress-determinate': {
                backgroundColor: 'background.elevation2',
              },
              '& .MuiLinearProgress-bar': {
                backgroundColor: 'text.primary',
              },
            }}
            value={(100 * totalPrice) / minimumOrderPrice}
          />
          <Typography variant="body-overline" fontWeight={700} textAlign="right">
            Minimum:
            {' '}
            {priceTransformer(minimumOrderPrice)}
          </Typography>
        </Stack>
      )}

      {renderButton()}
    </Stack>
  );
}

export default CartAction;
